var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.197,
    height: 18.125,
    viewBox: "0 0 15.197 18.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .activeHome {\r\n        fill: #1bc47d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid_General_Home",
    "data-name": "Solid / General /Home",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-0.402 -0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "activeHome",
    d: "M9.394.761A2.5,2.5,0,0,0,5.8.761L1,5.717A2.007,2.007,0,0,0,.472,6.751a28.756,28.756,0,0,0-.127,9.624L.521,17.5a.733.733,0,0,0,.725.62H4.6a.5.5,0,0,0,.5-.5v-7h5v7a.5.5,0,0,0,.5.5h3.353a.733.733,0,0,0,.724-.62l.177-1.13a28.759,28.759,0,0,0-.127-9.624,2.007,2.007,0,0,0-.532-1.034Z",
    transform: "translate(0.402 0.375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHome);
export default __webpack_public_path__ + "static/media/active-home.b56901083c718ee8bd172f12f9814417.svg";
export { ForwardRef as ReactComponent };